/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * dictionary:
 *   * 1 RANGE
 *   * 2 VALUES
 * 
 * @export
 */
export const ParameterTypes = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type ParameterTypes = typeof ParameterTypes[keyof typeof ParameterTypes];


export function instanceOfParameterTypes(value: any): boolean {
    for (const key in ParameterTypes) {
        if (Object.prototype.hasOwnProperty.call(ParameterTypes, key)) {
            if (ParameterTypes[key as keyof typeof ParameterTypes] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ParameterTypesFromJSON(json: any): ParameterTypes {
    return ParameterTypesFromJSONTyped(json, false);
}

export function ParameterTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterTypes {
    return json as ParameterTypes;
}

export function ParameterTypesToJSON(value?: ParameterTypes | null): any {
    return value as any;
}

export function ParameterTypesToJSONTyped(value: any, ignoreDiscriminator: boolean): ParameterTypes {
    return value as ParameterTypes;
}

